
import {
    VENDOR_ADD_TEAM_TABLE_REQUEST,
    VENDOR_ADD_TEAM_TABLE_SUCCESS,
    VENDOR_ADD_TEAM_TABLE_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";

export const VendorTeamTableAction = (vendorId,jobId) => {
    return function (dispatch) {
      dispatch({
        type: VENDOR_ADD_TEAM_TABLE_REQUEST,
        payload: true,
      });
                  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_team_member_for_apply_job?vendorId=${vendorId}&jobId=${jobId}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: VENDOR_ADD_TEAM_TABLE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  const loadAllDetailsPre = (data) => {
    console.log(".........",data)
    return {
      type: VENDOR_ADD_TEAM_TABLE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
 